/**
 * Main page
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var PlayerPanel = require('../modules/ui/player.panel'),
    Menu = require('../modules/menu'),

    app = require('mag-app'),
    page = new (require('stb-component-page'))({$node: document.getElementById('pMain')}),
    keys = require('stb-keys'),
    findIndex = require('array-find-index'),
    tools  = require('../modules/tools'),
    langs  = window.langs = require('cjs-iso-639'),
    systemPlayer = require('../modules/system.player'),
    equalizer = require('../modules/ui/equalizer'),
    spinner  = require('../modules/ui/spinner'),
    advertising = require('../modules/advertising/core'),
    displayInfo = require('../modules/infoWidget').displayInfo,
    sendPipIntent = require('../modules/pip.intent'),
    menuConstructor = require('../modules/menu.constructor'),
    exitTimeShift = require('../modules/exit.timeshift'),
    types = require('../modules/types'),
    modalActions = require('../modules/intent.modal.menu'),

    timer = {
        progress: null,
        contentInfo: null,
        panelHide: null,
        serverTimeShiftRequest: null,
        serverTimeShiftBufferProgress: null,
        serverEpgUpdateCurrentProgram: null,
        localTimeShiftBufferProgress: null,
        localTimeShiftAutoStart: null

    },
    playback = {
        duration: 0,
        currentTime: 0,
        contentType: null,
        capabilities: {
            timeshift: false
        },
        rewind: {
            isActive: false,
            startTime: 0,
            time: 0,
            timeout: null,
            timeoutDuration: 800,
            intervals: [0, 0, 10],
            // direction to rewind (true/ false)
            mode: null,
            // is rewind called from clear page
            remote: false,
            // timer to go back to clear page
            remoteTimer: null,
            // block call pause after rewind on TIZEN platform
            pauseBlockingState: false,
            pauseBlockingTimeout: null
        },
        subtitles: {
            index: null,
            currentIndex: null,
            currentPID: null,
            list: []
        },
        audioTracks: {
            list: [],
            current: null
        },
        retryOnError: {
            timeoutId: null,
            intervals: [5000, 5000, 10000, 15000, 30000],
            currentInterval: 0
        },
        startProgressTimer: function () {
            setCurrentProgress();
            clearInterval(timer.progress);
            timer.progress = setInterval(setCurrentProgress, 1000);
        },
        stopProgressTimer: function () {
            clearInterval(timer.progress);
        },
        tv: {
            epg: {
                array: [],
                currentIndex: 0
            },
            archive: {
                state: {
                    NOT_ACTIVE: 0,
                    PAUSED_NO_LINK: 1,
                    PAUSED_GET_LINK: 2,
                    PAUSED_GET_LINK_ERROR: 3,
                    PLAYING_FILE: 4,
                    PAUSE_FILE: 5
                },
                active: false,
                currentState: 0,
                array: [],
                currentIndex: 0,
                realProgram: false,
                inited: false,
                realProgramUrl: '',
                realProgramInited: false,
                realProgramPaused: false
            }
        },
        timeshift: {
            active: false,
            duration: 0
        }
    },
    playerControl = {
        play: false,
        rewind: false,
        forward: false,
        next: false,
        prev: false,
        nextChannel: false,
        prevChannel: false
    },
    $title = document.getElementById('contentTitle'),
    $program = document.getElementById('contentProgramTitle'),
    $mediaInfo = {
        codec: document.getElementById('codecInfo'),
        lang: document.getElementById('langInfo')
    },
    $icons = {
        timeshift: document.getElementById('iconTS')
    },

    PANEL_HIDE_TIMEOUT = 5,
    // hack for platforms that detect duration on hls streams
    durationDetected = false,
    menuElements = menuConstructor(),
    playConfig,
    mainMenu;

/* eslint no-use-before-define:0 */
/* eslint no-underscore-dangle:0 */
/* eslint max-lines:0 */


/**
 * Set current progress timeout handler
 */
function setCurrentProgress () {
    var curTime,
        time = systemPlayer.primary.position;

    playback.currentTime = systemPlayer.primary.position;
    if ( playback.timeshift.active ) {
        curTime = systemPlayer.primary.position;
        if ( systemPlayer.primary.position > systemPlayer.primary.duration ) {
            curTime = 0;
        }
        time = curTime - playback.timeshift.duration;
    } else if ( playback.tv.archive.active &&  playback.tv.archive.realProgram ) {
        // currentProgram = playback.tv.epg.array[playback.tv.archive.currentIndex];
        // // time = parseInt(+new Date() / 1000 - currentProgram.start, 10);
    }
    app.playerPanel.progressBar.set(time);

    time = tools.parseTime(time);
    app.playerPanel.$leftText.innerText = time.hour + ':' + time.min + ':' + time.sec;
}


function setServerTimeShiftBufferProgress () {
    var realTime = parseInt(Date.now() / 1000, 10),
        current = realTime - playback.tv.epg.array[playback.tv.archive.currentIndex].start;

    app.playerPanel.bufferBar.set(current);
}


function localTimeShiftBufferProgress () {
    app.playerPanel.bufferBar.set(playback.timeshift.duration++);
}


function onContentErrorNotify () {
    var intent = app.lastPrimaryIntent;

    spinner.hide();
    core.notify({
        title: gettext('Error playing content') + ': ' + (intent.data.title || intent.data.uri),
        icon: 'alert',
        type: 'error',
        timeout: 3000
    });

    // if we will retry playing bad stream we should show preloader before real calling play
    if ( intent.data.stream && intent.data.retryOnError ) {
        spinner.showAfter(3000);
    }

    if ( equalizer.active ) {
        equalizer.hide();
    }
}


/*eslint complexity:0 max-lines-per-function:0*/
function startPlay ( intent, callback ) {
    /*eslint max-statements:0*/
    function retryPlaybackHandler () {
        clearTimeout(playback.retryOnError.timeoutId);
        console.log('retry playback after ' + playback.retryOnError.intervals[playback.retryOnError.currentInterval]);

        playback.retryOnError.timeoutId = setTimeout(function () {
            console.log('retry playback on error');
            // need to get new channel url if we play tv channel
            if ( intent.data.tvChannel ) {
                // async callback
                intent.data.tvChannel.getUrl(function (error, data) {
                    if ( !error && data && data.url ) {
                        intent.data.uri = data.url;
                        systemPlayer.intent(intent, callback, playConfig, true);
                    }
                });
            } else {
                // sync play
                systemPlayer.intent(intent, callback, playConfig);
            }

        }, playback.retryOnError.intervals[playback.retryOnError.currentInterval]);

        if ( playback.retryOnError.currentInterval < playback.retryOnError.intervals.length - 1 ) {
            playback.retryOnError.currentInterval++;
        }
    }

    if ( !intent.data ) {
        callback(true, null);

        return;
    }

    console.log(intent, ':intent:');
    console.log('Play:> ' + intent.data.uri);

    durationDetected = false;
    spinner.show();
    tools.removePipOnAudioMime(intent);
    resetInfo(intent);
    $program.innerText = '';

    clearTimeout(timer.localTimeShiftAutoStart);
    clearInterval(timer.serverTimeShiftRequest);

    playback.contentType = null;
    playConfig = {};
    playback.audioTracks.list = [];
    playback.subtitles.list = [];

    playback.capabilities = {
        timeshift: false
    };
    playback.audioTracks.current = null;
    app.currentPlayIntent = intent;
    playback.tv.archive.active = false;
    playback.tv.archive.realProgram = false;
    playback.tv.archive.currentState = 0;
    playback.timeshift.active = false;
    $icons.timeshift.classList.remove('visible');
    // make link to current intent
    app.currentIntent = intent;
    clearTimeout(timer.serverEpgUpdateCurrentProgram);

    if ( intent.data.tvChannel ) {
        playback.capabilities.timeshift = intent.data.tvChannel['local_timeshift'] && ( app.timeshift && app.timeshift.checkAbility(intent.data));

    } else if ( app.timeshift && app.timeshift.checkAbility && app.timeshift.ALLOW_MANUAL ) {
        playback.capabilities.timeshift = app.timeshift.checkAbility(intent.data);
    }
    if ( app.timeshift.enable && app.playback.capabilities.timeshift ) {
        playConfig.solution = 'extTimeShift';

        intent.once('start', function () {
            if ( app.timeshift.enable && app.timeshift.delay ) {
                timer.localTimeShiftAutoStart = setTimeout(activateTimeShift, app.timeshift.delay);

            }
        });
    }

    if ( app.currentPlayIntent.mime === 'content/video') {
        playback.contentType = 'content/video';
        document.body.classList.add('transparent');
    } else if (app.currentPlayIntent.mime === 'content/audio') {
        playback.contentType = 'content/audio';
        document.body.classList.remove('transparent');
    }

    $title.innerText = intent.data.title || intent.data.uri;

    intent.addListeners({
        // start playback
        start: function () {
            var time = systemPlayer.primary.duration,
                currentTime;

            console.log('hide spinner on intent start');
            spinner.hide();

            if ( app.playback.tv.archive.active && app.playback.tv.archive.realProgram ) {
                playback.startProgressTimer();
                app.playerPanel.showPauseButton();
            }

            if ( equalizer.active ) {
                equalizer.show();
            }

            if (
                !time
                || (intent.data.tvChannel && playback.tv.archive.currentState !== playback.tv.archive.state.PLAYING_FILE)
            ) {
                return;
            }

            currentTime = systemPlayer.primary.position;
            playback.currentTime = currentTime;
            playback.retryOnError.currentInterval = 0;
            currentTime = tools.parseTime(currentTime);

            if ( !playback.capabilities.timeshift ) {
                app.playerPanel.$leftText.innerText = currentTime.hour + ':' + currentTime.min + ':' + currentTime.sec;
            }

            if (
                !playback.rewind.isActive
                && ((playback.capabilities.timeshift && playback.timeshift.active) || !playback.capabilities.timeshift )
            ) {
                playback.duration = time;
                playback.startProgressTimer();
                app.playerPanel.$leftText.innerText = currentTime.hour + ':' + currentTime.min + ':' + currentTime.sec;
            }
        },

        // end of playback
        end: function () {
            playback.stopProgressTimer();
            if ( equalizer.active ) {
                equalizer.hide();
            }
        },

        // recive content info event
        'content:info': function () {
            if ( systemPlayer.primary.videoInfo && systemPlayer.primary.videoInfo.width ) {
                if ( intent.mime === 'content/audio' ) {
                    playback.contentType = 'content/audio';
                } else {
                    document.body.classList.add('transparent');
                    playback.contentType = 'content/video';
                }
            } else if ( !playback.contentType ) {
                document.body.classList.remove('transparent');
                playback.contentType = 'content/audio';
            }

            if ( playback.contentType === 'content/audio' && !equalizer.active ) {
                equalizer.show();
            }
        },

        // app want to stop player playback
        'playback:stop': function () {
            spinner.hide();
            exitTimeShift();
            systemPlayer.primary.stop();
        },

        // update subtitle tracks event
        'tracks:update': subtitleTracksUpdate,

        // playback error event
        error: onContentErrorNotify,

        // app want to exit
        exit: onPlaybackHideHandler,

        // someone call intent close
        close: restoreSoundInPiP,

        // current playback plays with dual mono
        'content:dualMono': require('../modules/infoWidget').showDualMono
    });

    if ( intent.data.stream ) {
        intent.addListener('end', onContentErrorNotify);
    }

    if ( intent.data.volumeCorrection ) {
        core.plugins.settingsAudio.correction = intent.data.volumeCorrection;
    } else {
        core.plugins.settingsAudio.correction = 0;
    }

    if ( intent.data.retryOnError ) {
        intent.addListener('error', retryPlaybackHandler);
        // for streams we should use the same handlers on playback end event
        if ( intent.data.stream ) {
            intent.addListener('end', onContentErrorNotify);
            intent.addListener('end', retryPlaybackHandler);
        }
    }

    if ( !intent.events.end || !intent.events.end.length ) {
        //debug.inspect(intent.events);
        intent.once('end', function () {
            intent.close();
        });
    }

    intent.once('start', function () {
        var time = systemPlayer.primary.duration,
            currentTime;

        if ( playback.contentType === 'content/audio' ) {
            equalizer.show();
        }

        if ( time ) {

            // hack
            // on tizen and webos platform when channels is hls streams we detect duration
            // remember first time detection and do not show controls
            if ( !durationDetected && intent.data.tvChannel ) {
                durationDetected = true;

                return;
            }

            playerControl.forward = !(playback.capabilities.timeshift && app.timeshift && app.timeshift.enable && !playback.timeshift.active);
            playerControl.rewind = !(playback.capabilities.timeshift && app.timeshift && app.timeshift.enable && !playback.timeshift.active);
            playerControl.play = true;
            app.playerPanel.initButtons(playerControl);
            app.playerPanel.buttons.focusIndex(3);

            // instantly display current time if we are playing not stream with timeshift solution
            if ( !playback.capabilities.timeshift ) {
                currentTime = systemPlayer.primary.position;
                playback.currentTime = currentTime;
                currentTime = tools.parseTime(currentTime);
                app.playerPanel.$leftText.innerText = currentTime.hour + ':' + currentTime.min + ':' + currentTime.sec;
            }

            // prevent set interval if rewind is active
            if ( !playback.rewind.isActive && !playback.capabilities.timeshift ) {
                detectTotalDuration();
            }
        } else {
            app.playerPanel.progressBar.hide();
            playback.duration = null;
        }
    });

    intent.once('media:info', getMediaInfo);
    intent.once('start', function () {
        hidePanel(PANEL_HIDE_TIMEOUT);
    });

    // reinit buttons
    if ( intent.data.uri ) {
        updatePlayerControls(intent);
    }

    if ( intent.data.modalMenu && intent.data.modalMenu.length ) {
        modalActions.init(intent.data.modalMenu);
        modalActions.record = true;
    } else {
        modalActions.record = false;
    }

    systemPlayer.intent(intent, callback, playConfig);

    if ( intent.data.headless && intent.context ) {
        // do nothing. rework this later
    } else if ( intent.data.headless ) {
        app.route(app.pages.clear);
        app.pages.clear.panel.focus();
    } else if ( !intent.context ) {
        // mag322 rendering fix hack
        setTimeout(function () {
            if ( app.activePage !== app.pages.main ) {
                app.route(app.pages.main);
            }
            console.log('*****************************focus main menu');
            mainMenu.focus();
        }, 20);
    }
}


// update player controls on swapped intent
function updatePlayerControls ( intent, checkDuration ) {
    playerControl.play = systemPlayer.primary.duration && !intent.data.tvChannel && checkDuration;
    playerControl.rewind = playerControl.forward =
        systemPlayer.primary.duration && !intent.data.tvChannel && systemPlayer.primary.state !== 0;

    playerControl.prev = (intent.events.prev && intent.events.prev.length && intent.events.prev[0]);
    playerControl.next = (intent.events.next && intent.events.next.length && intent.events.next[0]);
    playerControl.prevChannel = (intent.events.prevChannel && intent.events.prevChannel.length && intent.events.prevChannel[0]);
    playerControl.nextChannel = (intent.events.nextChannel && intent.events.nextChannel.length && intent.events.nextChannel[0]);
    app.playerPanel.initButtons(playerControl);
    if ( app.playerPanel.buttons.$focusItem.data.disable ) {
        if ( playerControl.play ) {
            app.playerPanel.buttons.focusItem(app.playerPanel.buttons.$links.playPause);
        } else if ( app.playerPanel.buttons.enabledCount ) { /*eslint no-inner-declarations:0 vars-on-top:0*/
            var index;

            for ( index = 0; index < app.playerPanel.buttons.data[0].length; index++ ) {
                if ( !app.playerPanel.buttons.data[0][index].disable ) {
                    app.playerPanel.buttons.focusItem(app.playerPanel.buttons.map[0][index]);
                }
            }
        }
    }

    if ( intent.data.tvChannel ) {
        intent.data.tvChannel.getEpg(false, getServerEpgHandler);
    }
}


function getServerEpgHandler ( error, data ) {
    var index,
        currentTime = Date.now() / 1000;

    if ( error || !data || !data.length ) {
        return;
    }

    function findCurrentEpg ( epg ) {
        var state = false,
            newTime = +new Date() / 1000;

        if ( epg.end > newTime && epg.start < newTime ) {
            state = true;
        }

        return state;
    }

    playback.tv.epg.array = data;
    index = findIndex(playback.tv.epg.array.slice(), findCurrentEpg);

    if ( index >= 0 ) {
        playback.tv.epg.currentIndex = index;
        $program.innerText = playback.tv.epg.array[playback.tv.epg.currentIndex].title;
        clearTimeout(timer.serverEpgUpdateCurrentProgram);

        if ( app.lastPrimaryIntent.data.tvChannel.archive ) {
            playerControl.play = true;
            app.playerPanel.initButtons(playerControl);
            if ( page.activeComponent !== app.playerPanel.buttons ) {
                app.playerPanel.buttons.focusIndex(3);
            }
        }

        timer.serverEpgUpdateCurrentProgram = setTimeout(function nextCheck () {
            var epgIndex = findIndex(playback.tv.epg.array, findCurrentEpg),
                nowTime = +new Date(),
                timeoutTime;

            clearTimeout(timer.serverEpgUpdateCurrentProgram);
            if ( epgIndex ) {
                playback.tv.epg.currentIndex = epgIndex;
                $program.innerText = playback.tv.epg.array[playback.tv.epg.currentIndex].title;
                timeoutTime = (playback.tv.epg.array[playback.tv.epg.currentIndex].end * 1000) - nowTime;
                timer.serverEpgUpdateCurrentProgram = setTimeout(nextCheck, timeoutTime);
            }

        }, ((playback.tv.epg.array[playback.tv.epg.currentIndex].end * 1000) - (currentTime * 1000) + 2000));
    }
}


function detectTotalDuration () {
    var time = systemPlayer.primary.duration;

    if ( time ) {
        app.playerPanel.progressBar.show();
        app.playerPanel.progressBar.init({max: time});
        playback.duration = time;
        playback.startProgressTimer();
        time = tools.parseTime(time);
        app.playerPanel.$rightText.innerText = time.hour + ':' + time.min + ':' + time.sec;
    }
}


/**
 * Callback to handle content meta date
 *
 * @param {Object} data - data object
 */
function getMediaInfo ( data ) {
    var audioPid = systemPlayer.primary.audioPID,
        audioTrack,
        currentSubtitleTrack,
        lang;

    //{ audioTracks: [ { codecType: 3, lang: [], pid: 1 } ],
    //subtitlesTracks: [ { codecType: 33, lang: [], pid: 2 } ] }
    if ( data.audioTracks && data.audioTracks.length ) {
        data.audioTracks.forEach(function ( track ) {
            if ( track.pid === audioPid ) {
                audioTrack = track;
            }
        });
    }
    playback.audioTracks.list = data.audioTracks;
    playback.audioTracks.current = audioTrack;

    $mediaInfo.codec.src =  '';
    $mediaInfo.lang.innerText = '';
    if ( audioTrack ) {
        $mediaInfo.codec.src = tools.getCodecImageName(audioTrack.type);
        if ( audioTrack.lang && audioTrack.lang[0] ) {
            lang = audioTrack.lang[0];
        }
        if ( !lang || lang === 'und') {
            $mediaInfo.lang.innerText = '';
        } else {
            //$mediaInfo.lang.innerText = (lang.length > 2 ? langs['2T'][lang]: langs['1'][lang]);
            lang = langs['1'][lang] || langs['2T'][lang] || langs['2B'][lang] || [''];

            //$mediaInfo.lang.innerText = langs['1'][lang][0] || langs['2T'][lang][0] || langs['2B'][lang][0] || '';
            $mediaInfo.lang.innerText = lang[0];
        }
    }

    clearTimeout(timer.contentInfo);
    timer.contentInfo = setTimeout(function () {
        $mediaInfo.codec.src = '';
        $mediaInfo.lang.innerText = '';
    }, 5000);

    if ( data.subtitlesTracks && data.subtitlesTracks.length ) {
        menuElements = menuConstructor({subtitles: true}, app.lastPrimaryIntent);
        mainMenu.init({
            data: menuElements.data,
            size: menuElements.data.length,
            focusIndex: menuElements.focusIndex
        });
        playback.subtitles.list = data.subtitlesTracks;
        playback.subtitles.currentPID = systemPlayer.primary.subtitlesPID;
        if ( systemPlayer.primary.enableSubtitles ) {
            currentSubtitleTrack = getSubtitlesByPID(playback.subtitles.currentPID);
            playback.subtitles.current = currentSubtitleTrack.track;
            playback.subtitles.index = currentSubtitleTrack.index;
        }
    } else {
        playback.subtitles.current = null;
        playback.subtitles.currentPID = null;
        playback.subtitles.list = [];
    }
}


function subtitleTracksUpdate ( data ) {
    var currentSubtitleTrack;

    if ( data.tracks && data.tracks.length ) {
        menuElements = menuConstructor({subtitles: true}, app.lastPrimaryIntent);
        mainMenu.init({
            data: menuElements.data,
            size: menuElements.data.length,
            focusIndex: menuElements.focusIndex
        });
        playback.subtitles.list = data.tracks;
        playback.subtitles.currentPID = systemPlayer.primary.subtitlesPID;
        if ( systemPlayer.primary.enableSubtitles ) {
            currentSubtitleTrack = getSubtitlesByPID(playback.subtitles.currentPID);
            playback.subtitles.current = currentSubtitleTrack.track;
            playback.subtitles.index = currentSubtitleTrack.index;
        }
    } else {
        playback.subtitles.current = null;
        playback.subtitles.currentPID = null;
        playback.subtitles.list = [];
    }
}


function intentMenuHandler () {
    if ( app.currentPlayIntent.data.modalMenu && app.currentPlayIntent.data.modalMenu.length && !modalActions.visible ) {
        app.lastFocus = app.activePage.activeComponent || app.activePage;
        modalActions.show();
    }
}


function rewind ( forward, timeout ) {
    var to = 0,
        // if we rewind to the end of file just instantly stop playback end emit end
        endOfFile  = false,
        prefix = '',
        currentTime,
        maxRewindTo = playback.duration,
        index;

    if ( !playback.duration && !playback.tv.archive.active ) {
        return;
    }

    playback.rewind.pauseBlockingState = true;

    if ( playback.tv.archive.active && playback.tv.archive.realProgram ) {
        maxRewindTo = app.playerPanel.bufferBar.value;
    }

    // clearInterval(timer.progress);
    playback.stopProgressTimer();

    timeout = timeout || playback.rewind.timeoutDuration;

    if ( !playback.rewind.isActive ) {
        if ( app.activePage === app.pages.clear ) {
            app.route(app.pages.main);
            playback.rewind.remote = true;
        }
        if ( playback.tv.archive.active && playback.tv.archive.realProgram ) {
            playback.currentTime = app.playerPanel.progressBar.value;
        }
        app.playerPanel.$progressbar.classList.add('active');
        playback.rewind.isActive = true;
        playback.rewind.startTime = playback.currentTime;
        playback.rewind.time = playback.currentTime;
    }

    if ( playback.rewind.direction === forward ) {
        playback.rewind.intervals.splice(0, 1);
        playback.rewind.intervals[playback.rewind.intervals.length] = playback.rewind.intervals[playback.rewind.intervals.length - 1] + 10;
    } else {
        // new direction of rewind
        playback.rewind.intervals = [0, 0, 10];
        playback.rewind.direction = forward;
    }

    if ( playback.rewind.remote ) {
        app.playerPanel.buttons.focus();
        if ( forward ) {
            app.playerPanel.buttons.focusIndex(4);
        } else {
            app.playerPanel.buttons.focusIndex(2);
        }
    }

    for ( index = 0; index < playback.rewind.intervals.length; index++ ) {
        to += (forward ? 1 : -1) * playback.rewind.intervals[index];
    }
    if ( to > 1800 ) {
        to = 1800;
    }
    if ( to < -1800 ) {
        to = -1800;
    }

    playback.rewind.time += to;
    if ( playback.rewind.time >= maxRewindTo ) {
        playback.rewind.time = maxRewindTo;
        endOfFile = true;
    }
    if ( playback.rewind.time < 0 ) {
        playback.rewind.time = 3;
    }

    currentTime = playback.rewind.time;
    app.playerPanel.progressBar.set(playback.rewind.time);

    if ( playback.timeshift.active ) {
        currentTime = systemPlayer.primary.duration - playback.rewind.time;
        prefix = '- ';
    }
    currentTime = tools.parseTime(currentTime);

    app.playerPanel.$leftText.innerText = prefix + currentTime.hour + ':' + currentTime.min + ':' + currentTime.sec;

    clearTimeout(playback.rewind.timeout);

    playback.rewind.timeout = setTimeout(function () {
        if ( playback.tv.archive.active && playback.tv.archive.realProgram &&
            playback.tv.archive.currentState === playback.tv.archive.state.PAUSED_GET_LINK ) {
            setPos(true);
        } else {
            setPos();
        }

        function setPos ( playInsteadRewindUri ) {
            playback.rewind.isActive = false;
            if ( playInsteadRewindUri ) {
                //systemPlayer.play
                app.lastPrimaryIntent.data.uri = playback.tv.archive.realProgramUrl;
                app.lastPrimaryIntent.data.position = playback.rewind.time;
                playback.tv.archive.currentState = playback.tv.archive.state.PLAYING_FILE;
                systemPlayer.intent(app.lastPrimaryIntent);
            } else {

                console.log('player state is ' + systemPlayer.primary.state);
                console.log('try to rewind');
                systemPlayer.primary.position = playback.rewind.time;
                console.log('player state is ' + systemPlayer.primary.state);

                if ( playback.capabilities.timeshift && playback.timeshift.active && systemPlayer.primary.state === 3 ) {
                    playback.startProgressTimer();
                    systemPlayer.primary.position = playback.rewind.time;
                } else if ( endOfFile ) {
                    // instantly emit end and stop player
                    systemPlayer.primary.stop();
                    app.lastPrimaryIntent.emit('end');
                } else {
                    systemPlayer.primary.position = playback.rewind.time;
                }
            }
            playback.currentTime = playback.rewind.time;
            app.playerPanel.$progressbar.classList.remove('active');
            playback.rewind.mode = null;
            // restore rewind intervals
            playback.rewind.intervals = [0, 0, 10];
            if ( playback.rewind.remote ) {
                hidePanel(1);
                // go to clear page if rewind was initiated there
                playback.rewind.remote = false;
            }

            spinner.show();

            // after rewind and 600ms we unblock possibility to play/pause
            clearTimeout(playback.rewind.pauseBlockingTimeout);
            playback.rewind.pauseBlockingTimeout = setTimeout(function () {
                playback.rewind.pauseBlockingState = false;
            }, 600);
        }
    }, timeout);

    if ( equalizer.active ) {
        equalizer.pause();
    }
}


function nextAspect () {
    var currentAspect = systemPlayer.primary.aspect;

    if ( currentAspect < 5 ) {
        currentAspect++;
    } else {
        currentAspect = 0;
    }
    systemPlayer.primary.aspect = currentAspect;
    displayInfo({
        text: types.aspects[currentAspect],
        icon: 'H'
    });
}


function getSubtitlesByPID ( PID ) {
    var index, sub;

    for ( index = 0; index < playback.subtitles.list.length; index++ ) {
        sub = playback.subtitles.list[index];
        if ( sub.pid === PID ) {
            return {track: sub, index: index};
        }
    }

    return null;
}


function playPauseHandler ( config ) {
    config = config || config;

    if ( !playerControl.play ) {
        return;
    }

    if ( app.activePage !== page ) {
        app.route(app.pages.main);
        app.playerPanel.buttons.focusIndex(2);
    }

    if ( app.lastPrimaryIntent.data.tvChannel && app.lastPrimaryIntent.data.tvChannel.archive &&
        playback.tv.epg.array.length /*&& playback.tv.archive.array.length*/ && !playback.timeshift.active ) {
        serverTimeShiftPauseHandler();
    } else if ( app.timeshift && app.timeshift.enable && playback.capabilities.timeshift ) {
        localTimeShiftPauseHandler();
    } else {
        commonPlaybackPause(config);
    }
}


function stopPlaybackHandler () {
    // do not stop if force set stream content
    if ( app.lastPrimaryIntent && app.lastPrimaryIntent.data && app.lastPrimaryIntent.data.stream ) {
        return;
    }

    // stop playback only if we are playing non stream content or app will handle this event
    if (
        systemPlayer.primary.duration
        || (app.currentPlayIntent.events.stop && app.currentPlayIntent.events.stop.length)
    ) {
        exitTimeShift();
        systemPlayer.primary.stop();
        document.body.classList.remove('transparent');
        // clearInterval(timer.progress);
        playback.stopProgressTimer();
        app.playerPanel.$rightText.innerText = '00:00:00';
        app.playerPanel.$leftText.innerText = '00:00:00';
        app.playerPanel.progressBar.set(0);
        if ( app.currentPlayIntent ) {
            app.currentPlayIntent.emit('stop', {manual: true});
        }
    }
}


function commonPlaybackPause ( config ) {
    if ( PLATFORM === 'TIZEN' && playback.rewind.pauseBlockingState ) {
        // on tizen platform async seek may cause unhandled errors
        return;
    }
    config = config || {};

    console.log('pause::: state was ' + systemPlayer.primary.state);
    if ( config.forcePause ) {
        app.playerPanel.showPlayButton();
        systemPlayer.primary.pause();
    } else if ( config.forceResume ) {
        app.playerPanel.showPauseButton();
        systemPlayer.primary.resume();
        if ( playback.contentType === 'content/audio' ) {
            equalizer.show();
        }
    } else if ( systemPlayer.primary.state === systemPlayer.STATE_PLAYING ) {
        app.playerPanel.showPlayButton();
        playback.stopProgressTimer();
        systemPlayer.primary.pause();
        if ( equalizer.active ) {
            equalizer.pause();
        }
    } else if ( systemPlayer.primary.state === systemPlayer.STATE_PAUSE ) {
        app.playerPanel.showPauseButton();
        playback.startProgressTimer();
        systemPlayer.primary.resume();
        if ( playback.contentType === 'content/audio' ) {
            equalizer.show();
        }
    }
    console.log('pause::: state now is ' + systemPlayer.primary.state);
}


function serverTimeShiftPauseHandler () {
    var currentProgram;

    switch ( playback.tv.archive.currentState ) {
        case playback.tv.archive.state.NOT_ACTIVE:
            clearTimeout(timer.serverEpgUpdateCurrentProgram);
            playback.tv.archive.currentIndex = playback.tv.epg.currentIndex;
            currentProgram = playback.tv.epg.array[playback.tv.archive.currentIndex];
            if ( !currentProgram ) {
                return;
            }
            currentProgram.getLink(function ( error, data ) {
                var time;

                if ( data && data.url && !error ) {
                    systemPlayer.primary.pause();
                    playback.tv.archive.active = true;
                    playback.tv.archive.realProgramUrl = data.url;
                    playback.tv.archive.realProgram = true;
                    playback.tv.archive.currentState = playback.tv.archive.state.PAUSED_GET_LINK;
                    app.playerPanel.progressBar.init({
                        max: currentProgram.end - currentProgram.start,
                        value: parseInt((Date.now() / 1000) - currentProgram.start, 10)
                    });

                    app.playerPanel.bufferBar.init({
                        max: currentProgram.end - currentProgram.start,
                        value: parseInt((Date.now() / 1000) - currentProgram.start, 10)
                    });

                    app.playerPanel.progressBar.show();

                    app.playerPanel.bufferBar.show();
                    if ( playback.tv.epg.array[playback.tv.archive.currentIndex - 1] &&
                        playback.tv.epg.array[playback.tv.archive.currentIndex - 1].archive ) {
                        playerControl.prev = true;
                    }
                    playerControl.rewind = playerControl.forward = true;
                    app.playerPanel.initButtons(playerControl);
                    app.playerPanel.showPlayButton();

                    timer.serverTimeShiftBufferProgress = setInterval(setServerTimeShiftBufferProgress, 1000);
                    time = tools.parseTime(currentProgram.end - currentProgram.start);
                    app.playerPanel.$rightText.innerText = time.hour + ':' + time.min + ':' + time.sec;
                    time = tools.parseTime(parseInt((Date.now() / 1000) - currentProgram.start, 10));
                    app.playerPanel.$leftText.innerText = time.hour + ':' + time.min + ':' + time.sec;
                } else {
                    // error here
                    app.playerPanel.showPauseButton();
                    playback.tv.archive.currentState = playback.tv.archive.state.PAUSED_GET_LINK_ERROR;
                    core.notify({
                        title: gettext('Can not get current epg link'),
                        icon: 'alert',
                        type: 'error',
                        timeout: 2000
                    });
                }
            });
            break;
        case playback.tv.archive.state.PAUSED_GET_LINK:
            app.playerPanel.showPauseButton();
            app.lastPrimaryIntent.data.uri = playback.tv.archive.realProgramUrl;
            app.lastPrimaryIntent.data.position = app.playerPanel.progressBar.value - 10;
            app.lastPrimaryIntent.data.solution = 'ffmpeg';
            systemPlayer.intent(app.lastPrimaryIntent);
            playback.tv.archive.currentState = playback.tv.archive.state.PLAYING_FILE;
            // playback.startProgressTimer();
            break;
        case playback.tv.archive.state.PLAYING_FILE:
            commonPlaybackPause();
            if ( systemPlayer.primary.state === 3 ) {
                playback.stopProgressTimer();
            } else {
                playback.startProgressTimer();
            }
            break;
    }
}


function activateTimeShift ( config ) {
    var time;

    config = config || {};

    if ( !app.timeshift.path ) {
        if ( config.manual ) {
            core.notify({
                title: gettext('Mount usb device!'),
                icon: 'alert',
                timeout: 3000
            });
        }

        return false;
    }

    if ( tools.checkUsb(app.timeshift.mountUsb ) ) {
        // state = app.timeshift.enter();
        playback.timeshift.active = true;

        $icons.timeshift.classList.add('visible');
        time = tools.parseTime(app.timeshift.length);
        app.playerPanel.$rightText.innerText = time.hour + ':' + time.min + ':' + time.sec;
        playback.timeshift.duration = 0;

        app.playerPanel.progressBar.init({
            max: parseInt(app.timeshift.length, 10)
        });
        app.playerPanel.progressBar.show();
        app.playerPanel.bufferBar.init({
            max: parseInt(app.timeshift.length, 10)
        });
        app.playerPanel.bufferBar.show();
        playback.startProgressTimer();
        clearInterval(timer.localTimeShiftBufferProgress);
        timer.localTimeShiftBufferProgress = setInterval(localTimeShiftBufferProgress, 1000);
        playerControl.rewind = true;
        playerControl.forward = true;
        playback.duration = app.timeshift.length;
        app.playerPanel.initButtons(playerControl);

        return true;
    }

    core.notify({
        title: gettext('Mount usb device!'),
        icon: 'alert',
        timeout: 3000
    });

    return false;
}


function localTimeShiftPauseHandler () {
    if ( playback.timeshift.active ) {
        commonPlaybackPause();
    } else if ( activateTimeShift({manual: true}) ) {
        commonPlaybackPause();
        systemPlayer.primary.position = 1;
    }
}


function isEpgRealTime ( epg ) {
    var curr = Date.now() / 1000;

    return (epg.start < curr && epg.end > curr);
}


function serverTimeShiftNextPrevEpg ( state ) {
    // previouse content
    if ( !state ) { // eslint-disable-line
        playback.tv.archive.currentIndex--;
        playback.tv.epg.array[playback.tv.archive.currentIndex].getLink(function ( error, data ) {
            if ( data && data.url && !error ) {
                $program.innerText = playback.tv.epg.array[playback.tv.archive.currentIndex].title;
                app.lastPrimaryIntent.data.uri = data.url;
                app.lastPrimaryIntent.data.solution = 'ffmpeg';
                app.lastPrimaryIntent.once('start', detectTotalDuration);
                // app.lastPrimaryIntent.events.start.forEach(function (p1, p2, p3) {  })
                systemPlayer.intent(app.lastPrimaryIntent);
                playback.tv.archive.realProgram = false;
                playback.tv.archive.currentState = playback.tv.archive.state.PLAYING_FILE;
                if ( playback.tv.epg.array[playback.tv.archive.currentIndex - 1] &&
                    playback.tv.epg.array[playback.tv.archive.currentIndex - 1].archive ) {
                    playerControl.prev = true;
                } else {
                    playerControl.prev = false;
                }
                playerControl.next = true;
                app.playerPanel.initButtons(playerControl);
            } else {
                core.notify({
                    title: gettext('Can not get current epg link'),
                    icon: 'alert',
                    type: 'error',
                    timeout: 2000
                });
            }
        });
    } else {
        // next content
        if ( playback.tv.epg.array[playback.tv.archive.currentIndex + 1] && // eslint-disable-line
            (playback.tv.epg.array[playback.tv.archive.currentIndex + 1].archive ||
            !isEpgRealTime(playback.tv.epg.array[playback.tv.archive.currentIndex + 1]))) {
            playback.tv.archive.currentIndex++;
            playback.tv.epg.array[playback.tv.archive.currentIndex].getLink(function ( error, data ) {
                if ( data && data.url && !error ) {
                    $program.innerText = playback.tv.epg.array[playback.tv.archive.currentIndex].title;
                    app.lastPrimaryIntent.data.uri = data.url;
                    app.lastPrimaryIntent.data.solution = data.solution;
                    app.lastPrimaryIntent.once('start', detectTotalDuration);
                    systemPlayer.intent(app.lastPrimaryIntent);
                    playback.tv.archive.realProgram = false;
                    playback.tv.archive.currentState = playback.tv.archive.state.PLAYING_FILE;
                } else {
                    core.notify({
                        title: gettext('Can not get current epg link'),
                        icon: 'alert',
                        type: 'error',
                        timeout: 2000
                    });
                }
            });
        } else {
            // should play real program or just stream instead
            app.lastPrimaryIntent.data.tvChannel.getUrl(function ( error, data ) {
                if ( data && data.url && !error ) {
                    $program.innerText = '';
                    app.lastPrimaryIntent.data.uri = data.url;
                    app.lastPrimaryIntent.data.solution = data.solution;

                    app.lastPrimaryIntent.once('start', function () {
                        app.lastPrimaryIntent.data.tvChannel.getEpg(false, getServerEpgHandler);
                    });

                    playback.tv.archive.active = false;
                    playback.tv.archive.currentState = 0;
                    playerControl.next = false;
                    playerControl.prev = false;
                    playerControl.rewind = false;
                    playerControl.forward = false;
                    app.playerPanel.initButtons(playerControl);
                    systemPlayer.intent(app.lastPrimaryIntent);
                } else {
                    core.notify({
                        title: 'Error playing content: ' + (app.lastPrimaryIntent.data.title || app.lastPrimaryIntent.data.uri),
                        icon: 'alert',
                        type: 'error',
                        timeout: 3000
                    });
                }
            });
        }
    }
}


/**
 * Send initiator app to get next/prev content
 *
 * @param {boolean} state - state to get data: true - next, false - prev content
 */
function nextPrevContent ( state ) {
    if ( app.currentPlayIntent && !playback.tv.archive.active ) {
        if ( state && !app.currentPlayIntent.events.next ) {
            return;
        } else if ( !state && !app.currentPlayIntent.events.prev ) {
            return;
        }
    }

    exitTimeShift();
    playback.stopProgressTimer();
    systemPlayer.primary.stop();
    resetInfo(app.currentPlayIntent);
    if ( equalizer.active ) {
        equalizer.hide();
    }
    document.body.classList.remove('transparent');

    // give control to server timeshift handler
    if ( playback.tv.archive.active ) {
        serverTimeShiftNextPrevEpg(state);
    } else {
        exitTimeShift();
        systemPlayer.primary.stop();
        resetInfo();
        if ( state && app.currentPlayIntent.events.next ) {
            app.currentPlayIntent.emit('next');
        } else if ( !state && app.currentPlayIntent.events.prev ) {
            app.currentPlayIntent.emit('prev');
        }
    }
}


function nextPrevChannel ( state ) {
    exitTimeShift();
    playback.stopProgressTimer();
    systemPlayer.primary.stop();
    resetInfo(app.currentPlayIntent);
    if ( equalizer.active ) {
        equalizer.hide();
    }
    document.body.classList.remove('transparent');

    if ( state && app.currentPlayIntent.events.nextChannel ) {
        app.currentPlayIntent.emit('nextChannel');
    } else if ( !state && app.currentPlayIntent.events.prevChannel ) {
        app.currentPlayIntent.emit('prevChannel');
    }
}


function resetInfo ( intent ) {
    menuElements = menuConstructor(null, intent);
    core.plugins.settingsAudio.correction = 0;

    // clear rewind timeout and disable rewind mode
    clearTimeout(playback.rewind.timeout);
    playback.rewind.isActive = false;

    mainMenu.init({
        data: menuElements.data,
        size: menuElements.data.length,
        focusIndex: menuElements.focusIndex
    });
    playback.duration = null;
    playback.currentTime = 0;
    playback.retryOnError.currentInterval = 0;
    clearTimeout(playback.retryOnError.timeoutId);
    app.playerPanel.showPauseButton();
    app.playerPanel.$rightText.innerText = '';
    app.playerPanel.$leftText.innerText = '';
    app.playerPanel.progressBar.set(0);
    app.playerPanel.bufferBar.set(0);
    app.playerPanel.progressBar.hide();
    app.playerPanel.bufferBar.hide();
    $mediaInfo.codec.src = '';
    $mediaInfo.lang.innerText = '';
    //document.body.classList.remove('transparent');
    playback.rewind.pauseBlockingState = false;
    clearTimeout(playback.rewind.pauseBlockingTimeout);
}


/**
 * Function to handle player hide or initial app hide
 */
function onPlaybackHideHandler () {
    modalActions.hide();

    exitTimeShift();
    systemPlayer.primary.stop();
    equalizer.hide();
    resetInfo();
    playback.stopProgressTimer();
    spinner.hide();
    restoreSoundInPiP();

    // reset player to set fullscreen
    // TODO: check if we need to do this for all platforms without this check
    if ( core.device && ( core.device.model.indexOf('emulator') > -1 || core.device.model.indexOf('android') > -1) ) {
        systemPlayer.reset();
    }

    app.lastPrimaryIntent = null;
}


/**
 * Restore audio focus in PiP if needded
 */
function restoreSoundInPiP () {
    if ( app.pipPlayer && app.pipPlayer.state ) {
        systemPlayer.setAudioSource(app.pipPlayer);
    }
}


function hidePanel ( sec ) {
    sec = sec || 5;

    clearTimeout(timer.panelHide);
    timer.panelHide = setTimeout(function () {
        app.route(app.pages.clear);
    }, 1000 * sec);
}

app.playback = playback;

page.add(mainMenu = app.mainMenu = new Menu({
    $node: document.getElementById('pMainMenu'),
    focusIndex: menuElements.focusIndex,
    size: menuElements.data.length,
    propagate: false,
    data: menuElements.data,
    events: {
        keydown: function ( event ) {
            Menu.prototype.defaultEvents.keydown.call(this, event);
            if ( event.code === keys.up ) {
                if ( app.playerPanel.buttons.enabledCount ) {
                    app.playerPanel.focus();
                }
            }
        }
    }
}));

page.add(
    app.playerPanel = new PlayerPanel({
        $node: document.getElementById('pMainPlayerPanel'),
        //progressBar: false,
        onPlay: playPauseHandler,
        onRewind: function ( event ) {
            // debug.inspect(event);
            if ( event.direction === keys.right ) {
                rewind(true, 2500);
            } else if ( event.direction === keys.left ) {
                rewind(false, 2500);
            }
        },
        onPrevNext: function ( event ) {
            switch ( event.direction ) {
                case keys.right:
                    nextPrevContent(true);
                    break;
                case keys.left:
                    nextPrevContent(false);
                    break;
            }
        },
        onChannels: function ( event ) {
            switch ( event.direction ) {
                case keys.right:
                    nextPrevChannel(true);
                    break;
                case keys.left:
                    nextPrevChannel(false);
                    break;
            }
        },
        events: {
            keydown: function ( event ) {
                if ( event.code === keys.down ) {
                    mainMenu.focus();
                }
            }
        }
    })
);

app.rewind = rewind;
app.nextPrevContent = function ( state ) {
    if (app.currentPlayIntent.events.next || app.currentPlayIntent.events.prev ) {
        nextPrevContent(state);
    } else if ( app.currentPlayIntent.events.nextChannel ||  app.currentPlayIntent.events.prevChannel ) {
        nextPrevChannel(state);
    }
};

core.addListeners({
    // intent listener handler
    intent: function ( intent, callback ) {
        if ( intent.action !== 'play' ) {

            return;
        }
        resetInfo(intent);

        // check if we need play advertising with this intent
        advertising.checkIntent(intent, function () {
            startPlay(intent, callback);
        });
    },

    // core event hide handler
    hide: function ( event ) {
        console.log(event, 'hide event');

        if (
            // hide by some intent call show
            event.source === core.SOURCES.INTENT
            // player hide by pip events (maximize, etc)
            || event.source === core.SOURCES.SYSTEM
        ) {
            // here will process some actions
            console.log('do not stop playback');

            return;
        }

        if ( app.activePage === app.pages.settings ) {
            app.route(app.pages.clear);
        }

        if ( app.lastPrimaryIntent ) {
            // emit to initiate app that player is hide
            app.lastPrimaryIntent.emit('hide');
        }
        onPlaybackHideHandler();
    }
});

app.addListeners({
    // close app event
    close: function () {
        playback.stopProgressTimer();
        clearTimeout(timer.localTimeShiftAutoStart);
        if ( equalizer.active ) {
            equalizer.hide();
        }
        if ( !app.pipIntent ) {
            systemPlayer.reset();
        }

        spinner.hide();
    },

    // player swap event
    swap: function () {
        updatePlayerControls(app.currentPlayIntent, true);
    },

    // keydown event handler
    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.stop:
                stopPlaybackHandler();
                break;
            case keys.forward:
                rewind(true);
                break;
            case keys.rewind:
                rewind(false);
                break;
            case keys.playPause:
            case 32:
                playPauseHandler();
                break;
            case keys.play:
                playPauseHandler({forceResume: true});
                break;
            case keys.pause:
                playPauseHandler({forcePause: true});
                break;
            case keys.channelNext:
                if ( app.currentPlayIntent && app.currentPlayIntent.events.nextChannel) {
                    nextPrevChannel(true);
                }
                break;
            case keys.channelPrev:
                if ( app.currentPlayIntent && app.currentPlayIntent.events.prevChannel) {
                    nextPrevChannel(false);
                }
                break;
            case keys.pageDown:
                nextPrevContent(true);
                break;
            case keys.pageUp:
                nextPrevContent(false);
                break;
            case keys.exit:
                if ( PLATFORM === 'TIZEN' ) {
                    playback.stopProgressTimer();
                    systemPlayer.primary.stop();
                    equalizer.hide();
                    resetInfo();
                    app.currentPlayIntent.close();
                }
                break;
            case keys.info:
                if ( app.currentPlayIntent.events.onInfoPress ) {
                    app.currentPlayIntent.emit('onInfoPress');
                }
                break;
            case keys.frame:
                nextAspect();
                break;
            case keys.refresh:
                if ( !app.pipIntent ) {
                    sendPipIntent();
                }
                break;
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //sendOsdInputIntent(String.fromCharCode(event.code));
                if ( app.currentPlayIntent.events.onNumberPress ) {
                    app.currentPlayIntent.emit('onNumberPress', {number: String.fromCharCode(event.code)});
                }
                break;
            case keys.menu:
                intentMenuHandler();
                break;
        }
    }
});

page.addListener('keydown', function ( event ) {
    clearTimeout(timer.panelHide);

    if ( playback.rewind.remote ) {
        switch ( event.code ) {
            case keys.right:
                rewind(true);
                break;
            case keys.left:
                rewind(false);
                break;
        }

        return;
    }

    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.clear);
            break;
        case keys.info:
            app.route(app.pages.clear);
            break;
    }
});

app.playerPanel.initButtons(playerControl);
app.ready();
resetInfo();

if ( app.timeshift ) {
    require('../modules/ts.listeners');
}

if ( core.device && core.device.model === 'emulator' ) {
    require('../modules/settings/video.options').setValue(core.environment.playerHardwareAcceleration || false);
}

setTimeout(function () {
    mainMenu.focus();
});

if ( DEVELOP ) {
    window.playback = playback;
}


// public
module.exports = page;
